export default __webpack_public_path__ + "static/media/phone.37227273.png";